import React from "react";
import "./style.scss";

const Ornaments1 = (props) => {
    return (
        <div className={`${props.className || ''} ornament ornament-1`} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/game/ornament/ornaments-1.svg)` }}></div>
    )
}
const Ornaments2 = (props) => {
    return (
        <div className={`${props.className || ''} ornament ornament-2`} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/game/ornament/ornaments-2.svg)` }}></div>
    )
}
const Ornaments3 = (props) => {
    return (
        <div className={`${props.className || ''} ornament ornament-3`} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/game/ornament/ornaments-3.svg)` }}></div>
    )
}

const BackgroundWithOrnaments = (props) => {
    return (
        <div {...props} className={`${props.className || ''} background-ornaments bg-ornaments--title`}>
            <Ornaments3 className="left" />
            {props.children}
            <Ornaments3 className="right" />
        </div>
    )
}

const ExpoOrnaments = (props) => {
    return (
        <div className="expo-ornaments">
            <div className="ornament-tiles">
                <span className="square-green"></span>
                <span className="square-pink"></span>
                <span className="square-blue"></span>
                <span className="island-orange"></span>
            </div>
            <div className="ornament-body">
                <div className="ornament-body__content">
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export { Ornaments1, Ornaments2, Ornaments3, BackgroundWithOrnaments, ExpoOrnaments }